import React from 'react'
import { useToggleFavorite } from './ButtonToggleFavorite.hooks'
import type { ButtonToggleFavoriteProps } from './ButtonToggleFavorite.types'
import {
  ButtonFavorite,
  Text,
  ContentButton
} from './ButtonToggleFavorite.styles'
import { useTranslation } from 'i18n'

const ButtonToggleFavorite: React.FC<ButtonToggleFavoriteProps> = ({
  slug,
  noBorder,
  hasText
}) => {
  const { t } = useTranslation()
  const { loading, isFavorite, addToFavorites, removeFromFavorites } =
    useToggleFavorite({
      slug
    })
  const sizeIcon = noBorder ? 'large' : 'xLarge'

  return isFavorite ? (
    <ContentButton hasText={hasText} onClick={removeFromFavorites}>
      <ButtonFavorite
        iconName={'heart-fill'}
        theme={{ type: 'secondary', size: sizeIcon }}
        disabled={loading}
        noBorder={noBorder}
        aria-label="Desfavoritar livro"
      />
      {hasText && <Text>{t('Remover de Favoritos')}</Text>}
    </ContentButton>
  ) : (
    <ContentButton hasText={hasText} onClick={addToFavorites}>
      <ButtonFavorite
        iconName={'heart'}
        theme={{ type: 'secondary', size: sizeIcon }}
        disabled={loading}
        noBorder={noBorder}
        aria-label="Favoritar livro"
      />
      {hasText && <Text>{t('Favoritar')}</Text>}
    </ContentButton>
  )
}

export default ButtonToggleFavorite
